module.exports = __webpack_public_path__ + "img/hardware5.86a1b835.png";